/* eslint-disable no-restricted-syntax */
import { diContainer, serviceNames } from './service-setup/diContainer';
import { setupServiceInfo } from '@estee/elc-universal-utils';

export { TranslationsService } from './service-setup/TranslationsService';
diContainer.get(serviceNames.translationsService).register();

setupServiceInfo(__serviceInfo__);
